import React, { Component } from "react";
import { AUTH_TOKEN, USER_ID } from "../constants";
import { Mutation, withApollo } from "react-apollo";
import { Link as LinkTo } from "react-router-dom";
import gql from "graphql-tag";

const SIGNUP_MUTATION = gql`
  mutation SignupMutation($email: String!, $password: String!, $name: String!) {
    signup(email: $email, password: $password, name: $name) {
      token
      user {
        id
      }
    }
  }
`;

const LOGIN_MUTATION = gql`
  mutation LoginMutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
        name
        email
        created
      }
    }
  }
`;

class Login extends Component {
  state = {
    login: true, // switch between Login and SignUp
    email: "",
    password: "",
    name: "",
    error: "",
  };

  render() {
    const { login, email, password, name } = this.state;
    return (
      <Mutation
        mutation={login ? LOGIN_MUTATION : SIGNUP_MUTATION}
        variables={{ email, password, name }}
        onCompleted={(data) => this._confirm(data)}
        onError={(data) => {
          if (data.graphQLErrors && data.graphQLErrors.length) {
            this.setState({
              error: data.graphQLErrors[0],
            });
          } else {
            this.setState({
              error: "An error occured when posting the form",
            });
          }
        }}
      >
        {(mutation) => (
          <div>
            <h4 className="mv3">{login ? "Login" : "Sign Up"}</h4>
            <div className="flex flex-column">
              {!login && (
                <input
                  value={name}
                  onChange={(e) => {
                    this.setState({ name: e.target.value, error: "" });
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      mutation();
                    }
                  }}
                  type="text"
                  placeholder="Your nickname"
                />
              )}
              <input
                value={email}
                onChange={(e) =>
                  this.setState({ email: e.target.value, error: "" })
                }
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    mutation();
                  }
                }}
                type="text"
                placeholder="Your email address"
              />
              <input
                value={password}
                onChange={(e) =>
                  this.setState({ password: e.target.value, error: "" })
                }
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    mutation();
                  }
                }}
                type="password"
                placeholder={login ? "Password" : "Choose a safe password"}
              />
            </div>
            {!!this.state.error.length && (
              <div className="pt2 pl1">{this.state.error}</div>
            )}
            <div className="flex mt2">
              {login ? (
                <button
                  type="submit"
                  className="pointer mr2 button sg_login-action"
                  onClick={mutation}
                >
                  login
                </button>
              ) : (
                <button
                  type="submit"
                  className="pointer mr2 button sg_create-account-action"
                  onClick={mutation}
                >
                  create account
                </button>
              )}
              <div
                className="pointer button mr2"
                onClick={() => this.setState({ login: !login, error: "" })}
              >
                {login
                  ? "need to create an account?"
                  : "already have an account?"}
              </div>

              <LinkTo to="forgotpassword">
                <button className="pointer button no-underline sg_forgot-pw">
                  forgot password
                </button>
              </LinkTo>
            </div>
          </div>
        )}
      </Mutation>
    );
  }

  _confirm = async (data) => {
    const { token, user } = this.state.login ? data.login : data.signup;
    this._saveUserData(token, user.id);
    window.location.href = "/";
  };

  _saveUserData = (token, id) => {
    localStorage.setItem(AUTH_TOKEN, token);
    localStorage.setItem(USER_ID, id);
  };
}

export default withApollo(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js